import React from 'react';
import {Link, withRouter} from 'react-router-dom';
import PropTypes from "prop-types";
import Lockable from "components/Lockable";
import Framework from '@beardeddevops/react.framework';

class SidebarContent extends Lockable {

	static propTypes = {
		locations: PropTypes.array,
	};

	render() {
		return (
			<>
				<li>
					<Link data-id={'dashboard'} variant={"text"} to="/dashboard">
						<i className="fa fa-tachometer"/>
						<span className="nav-text">Dashboard</span>
					</Link>
				</li>
				<li>
					<Link data-id={'users'} variant={"text"} to="/users">
						<i className="fa fa-users"/>
						<span className="nav-text">Users</span>
					</Link>
				</li>
				<li>
					<Link data-id={'admins'} variant={"text"} to="/admins">
						<i className="fa fa-users"/>
						<span className="nav-text">Admins</span>
					</Link>
				</li>
				<li>
					<Link data-id={'access-logs'} variant={"text"} to="/access">
						<i className="fa fa-file-text-o"/>
						<span className="nav-text">Access Log</span>
					</Link>
				</li>
				<li>
					<Link data-id={'ip-whitelists'} variant={"text"} to="/ip_whitelists">
						<i className="fa fa-shield"/>
						<span className="nav-text">IP Whitelist</span>
					</Link>
				</li>
				<li>
					<Link data-id={'two-steps'} variant={"text"} to="/two_steps">
						<i className="fa fa-lock"/>
						<span className="nav-text">Two Step</span>
					</Link>
				</li>
				<li>
					<Link data-id={'financials'} variant={"text"} to="/financials">
						<i className="fa fa-usd"/>
						<span className="nav-text">Financials</span>
					</Link>
				</li>
				<li>
					<Link data-id={'account-activity'} variant={"text"} to="/account_activity">
						<i className="fa fa-line-chart"/>
						<span className="nav-text">Account Activity</span>
					</Link>
				</li>
				<li>
					<Link data-id={'marketing'} variant={"text"} to="/marketing">
						<i className="fa fa-bullhorn"/>
						<span className="nav-text">Marketing</span>
					</Link>
				</li>
				<li>
					<Link data-id={'email-template'} variant={"text"} to="/email_templates">
						<i className="fa fa-envelope-o"/>
						<span className="nav-text">Email Templates</span>
					</Link>
				</li>
				<li>
					<Link data-id={'analytics'} variant={"text"} to="/analytics">
						<i className="fa fa-bar-chart"/>
						<span className="nav-text">Analytics</span>
					</Link>
				</li>
			</>
		);
	}
}

export default Framework.Components.withRootState(withRouter(SidebarContent));
